module.exports = __webpack_public_path__ + "img/4-2.6070295e.png";